import dismissStorage from '../utils/storage/dismiss-storage';

var subscribe = function(oneSignal, behaviourPromise, prompt){
    if (behaviourPromise) {
        return behaviourPromise.then(function(strategy){
            if ( (strategy || {}).custom ) {
                return strategy.custom(function(){
                    oneSignal.registerForPushNotifications();
                });
            } else {
                if ( (strategy || {}).prompt ) prompt = strategy.prompt;
                return promisifyPrompt(prompt)
                    .then(function(){
                        return oneSignal.registerForPushNotifications();
                    })
                    .catch(function(reason){
                        // expected to get some throw or reject from the prompt
                        // might be necessary to have some specific reason later
                        // to be sure to distinguish dismissing and some real
                        // troubles that could happen in the prompt code
                        dismissStorage.dismiss();
                    });
            }
        });
    } else {
        return Promise.resolve(oneSignal.registerForPushNotifications());
    }
}

var promisifyPrompt = function(prompt) {
    if (typeof(prompt) === 'function') {
        return prompt();
    } else {
        return Promise.resolve();
    }
}

export default subscribe;



//////////////////
// WEBPACK FOOTER
// ./src/app/subscribe.js
// module id = 13
// module chunks = 0